import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Stat } from "@/components/Layout";
import { api, fmtDate, gbp } from "@/lib/api";

export const AdminUsage = () => {
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [d, setD] = useState(null);
  useEffect(() => { setD(null); api.get("/admin/usage", { params: { month } }).then((r) => setD(r.data)); }, [month]);
  return (
    <div className="space-y-5" data-testid="admin-usage">
      <div className="flex flex-wrap items-center gap-3">
        <input data-testid="admin-usage-month" type="month" value={month} onChange={(e) => e.target.value && setMonth(e.target.value)} className="h-10 px-3 rounded-lg border border-slate-200 dark:border-slate-700 bg-transparent text-sm" />
        <p className="text-sm text-slate-500">API letters billed on monthly statements. Invoice each account for its total.</p>
      </div>
      {!d ? <Loader2 className="animate-spin text-emerald-600" /> : (
        <>
          <div className="grid grid-cols-2 gap-4 max-w-lg">
            <Stat testId="admin-usage-count" label="API letters" value={d.count} />
            <Stat testId="admin-usage-total" label="To invoice" value={gbp(d.total_gbp)} accent />
          </div>
          <div className="overflow-x-auto rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900">
            <table className="w-full text-sm" data-testid="admin-usage-table">
              <thead><tr className="text-left text-[11px] uppercase tracking-wider text-slate-500 border-b border-slate-200 dark:border-slate-800">
                {["Account", "Letters", "Amount", "Last send"].map((h) => <th key={h} className="px-4 py-3 font-semibold">{h}</th>)}</tr></thead>
              <tbody>{d.accounts.map((a) => (
                <tr key={a.user_id} className="border-b last:border-0 border-slate-100 dark:border-slate-800">
                  <td className="px-4 py-3">{a.org_name || a.email}</td><td className="px-4 py-3">{a.count}</td><td className="px-4 py-3 font-semibold">{gbp(a.total_gbp)}</td>
                  <td className="px-4 py-3 font-mono text-xs">{fmtDate(a.last_send_at)}</td>
                </tr>))}</tbody>
            </table>
            {!d.accounts.length && <p className="text-sm text-slate-500 p-6 text-center">No API usage this month.</p>}
          </div>
        </>
      )}
    </div>
  );
};
